import { Injectable } from '@angular/core';
import { RestService } from '../../../shared/services/rest-service';
import { ISearchResult } from 'src/app/core/models/i-search-result';
import { Observable } from 'rxjs';
import { ICreateDataResponse } from 'src/app/core/models/i-create-data-response';

@Injectable({
  providedIn: 'root',
})
export class DigitalPublicationDataService {
  static readonly ENTITY_IDENTIFIER: string = 'digitalPublicationsData';
  private readonly BASE_EXTERNAL_DATA_ROUTE = `api/${DigitalPublicationDataService.ENTITY_IDENTIFIER}`;
  private readonly BUILD_HTTP_ROUTE = (...args) =>
    this.restService.BUILD_HTTP_ROUTE(this.BASE_EXTERNAL_DATA_ROUTE, ...args);

  constructor(private restService: RestService) {}

  searchClients$(searchText: string): Observable<ISearchResult> {
    const params = this.restService.buildHttpParamsObject({
      searchText: searchText.trim(),
    });

    return this.restService.get$<ISearchResult>(
      this.BUILD_HTTP_ROUTE('clients'),
      { params }
    );
  }

  createClient$(text: string): Observable<ICreateDataResponse> {
    return this.restService.post$<ICreateDataResponse>(
      this.BUILD_HTTP_ROUTE('clients'),
      {
        text: text,
      }
    );
  }

  searchProducts$(searchText: string): Observable<ISearchResult> {
    const params = this.restService.buildHttpParamsObject({
      searchText: searchText.trim(),
    });

    return this.restService.get$<ISearchResult>(
      this.BUILD_HTTP_ROUTE('products'),
      { params }
    );
  }

  createProduct$(text: string): Observable<ICreateDataResponse> {
    return this.restService.post$<ICreateDataResponse>(
      this.BUILD_HTTP_ROUTE('products'),
      {
        text: text,
      }
    );
  }

  searchPlatforms$(searchText: string): Observable<ISearchResult> {
    const params = this.restService.buildHttpParamsObject({
      searchText: searchText.trim(),
    });

    return this.restService.get$<ISearchResult>(
      this.BUILD_HTTP_ROUTE('platforms'),
      { params }
    );
  }

  createPlatform$(text: string): Observable<ICreateDataResponse> {
    return this.restService.post$<ICreateDataResponse>(
      this.BUILD_HTTP_ROUTE('platforms'),
      {
        text: text,
      }
    );
  }
}
